export const parseEnumValue = <T extends Record<string, string | number>>(
    input: string,
    enumeration: T
): T[keyof T] | undefined => {
    const normalizedInput = input.toUpperCase();

    const matchedKey = (Object.keys(enumeration) as Array<keyof T>).find((key) => {
        const enumValue = enumeration[key];
        if (typeof enumValue === 'string') {
            return enumValue.toUpperCase() === normalizedInput;
        }
        return false;
    });

    return matchedKey ? enumeration[matchedKey] : undefined;
};

export const getRandomEnumValue = <T extends Record<string, string | number>>(
    anEnum: T,
    exclude: Array<T[keyof T]> = []
): T[keyof T] => {
    const enumValues = Object.values(anEnum).filter(
        (value) => !exclude.includes(value as T[keyof T])
    ) as T[keyof T][];
    const randomIndex = Math.floor(Math.random() * enumValues.length);
    return enumValues[randomIndex];
};
